/* APOCALISSE SOLD OUT - il pulsante WhatsApp sale sopra il badge anti-spam (hCaptcha / reCAPTCHA) quando questo compare in basso a destra,
   cosi i due non si sovrappongono. Imposta la variabile --aso-cap-lift, letta da assets/aso-whatsapp.css. */
(function () {
  if (window.__asoCap) return;
  window.__asoCap = 1;
  var H = document.documentElement, last = -1, n = 0;
  var SEL = 'iframe[src*="hcaptcha"],iframe[title*="aptcha"],.grecaptcha-badge,[class*="captcha-badge"],[id*="hcaptcha"]';
  function calc() {
    var els = document.querySelectorAll(SEL), need = 0, ih = window.innerHeight, iw = window.innerWidth;
    [].forEach.call(els, function (e) {
      var r = e.getBoundingClientRect();
      if (r.width < 20 || r.height < 20 || r.top < ih * 0.35 || r.top > ih || r.bottom < 0 || r.right < iw - 160) return;
      need = Math.max(need, Math.round(ih - r.top + 10 - 16));
    });
    if (need !== last) {
      last = need;
      H.style.setProperty('--aso-cap-lift', need + 'px');
    }
  }
  function go() {
    calc();
    if (window.MutationObserver) new MutationObserver(calc).observe(document.body, { childList: true });
    window.addEventListener('resize', calc);
    window.addEventListener('load', function () { setTimeout(calc, 600); });
    var t = setInterval(function () { calc(); if (++n > 14) clearInterval(t); }, 1500);
  }
  if (document.body) go(); else document.addEventListener('DOMContentLoaded', go);
})();